export default __webpack_public_path__ + "static/media/icon-oportunidade.d30b7c15.svg";